import React from "react";
import "./FreeTrialBanner.css";
import images from "../../../../utilities/images/images";

const FreeTrialBanner = ({
  trialDays,
  handleEnrollClick,
  popupDescription,
  popupTitle,
}) => {
  const onEnrollClick = () => {
    if (typeof handleEnrollClick === "function") {
      handleEnrollClick();
    } else {
      console.error("handleEnrollClick is not a function:", handleEnrollClick);
    }
  };

  return (
    <div className="free-trial-banner">
      <div className="banner-left">
        <img
          src={images.ansBannerIcon}
          alt="Free Trial Icon"
          className="icon"
        />
        <div className="text">
          <h3>{popupTitle}</h3>
          <p>{popupDescription}</p>
        </div>
      </div>
      <button className="enroll-button" onClick={onEnrollClick}>
        Enroll Now
      </button>
    </div>
  );
};

export default FreeTrialBanner;
